import {
  Account,
  ProfileFormValues,
  ProfileFormValuesRequest,
  VerifyAccountRequest,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestContentType } from "@core/services/http/http.type";
import { map } from "rxjs";

class _AccountService {
  //get profile
  public getMyInfo() {
    return HttpService.get<Account>("/accounts/me");
  }

  public updateProfile(updateProfileInfor: ProfileFormValuesRequest) {
    return HttpService.patch<Account>("/accounts/me", {
      body: { ...updateProfileInfor },
    });
  }

  // public verifyAccount(verifyAccountRequest: VerifyAccountRequest) {
  //   return HttpService.patch<Account>("/accounts", {
  //     requestContentType: RequestContentType.MULTIPART,
  //     body: { ...verifyAccountRequest },
  //   });
  // }

  public verifyPhone() {
    return HttpService.get<Account>("/accounts/verify-phone");
  }

  public verifyAccount(verifyAccountRequest: VerifyAccountRequest) {
    return HttpService.patch<Account>("/accounts", {
      body: { ...verifyAccountRequest },
    });
  }

  public getContract(username: string, otp: string) {
    // Truyền thêm object rỗng {} ở tham số thứ 2
    return HttpService.requestDownload(
      `/accounts/contract/${username}?otp=${otp}`,
      {}
    ).pipe(map((ajaxResponse) => ajaxResponse.response as Blob));
  }
}

const AccountService = new _AccountService();

export default AccountService;
